import { render, staticRenderFns } from "./ConfigShowTeachTablePanel.vue?vue&type=template&id=bc49c32c"
import script from "./ConfigShowTeachTablePanel.vue?vue&type=script&lang=js"
export * from "./ConfigShowTeachTablePanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports